//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ChemicalStaticList from "./ChemicalStaticList";
export default {
  components: {
    ChemicalStaticList: ChemicalStaticList
  },
  data: function data() {
    return {
      tabKeys: "3"
    };
  },
  created: function created() {
    this.tabKeys = "3";
  },
  computed: {},
  methods: {}
};